module.exports = __webpack_public_path__ + "img/GH-kyujin-top-back005-2sp.1282e0b9.webp";